export abstract class BaseEvent<Detail extends object> {
  readonly version = "1.0" as const;
  readonly id = crypto.randomUUID();
  readonly time = new Date().toISOString();
  readonly source = "fideus" as const;
  readonly "detail-type": string;
  readonly resources: string[];
  readonly detail: Detail;

  constructor(detail: Detail, resources?: string[]) {
    this.resources = resources ?? [];
    this.detail = detail;
  }
}
